import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClientEspNdc } from '../models/client-esp-ndc.model';
import { LimitOffsetPaging, LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { ClientEspNdcFilters } from '../models/user-settings/client-esp-ndc-settings.model';

export class PagedClientEspNdcs implements PagedResults {
  clientEspNdcs: ClientEspNdc[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.clientEspNdcs;
  }
}

@Injectable()
export class ClientEspNdcsService extends ApiService {
  private http = inject(HttpClient);

  getList(
    paging: LimitOffsetPaging,
    filters: ClientEspNdcFilters
  ): Observable<PagedClientEspNdcs> {
    const params = new URLSearchParams();

    if (filters) {
      if (filters.ndc) {
        params.append('ndc', filters.ndc);
      }

      if (filters.drugDescription) {
        params.append('drug_description', filters.drugDescription);
      }

      if (filters.selectedManufacturers) {
        filters.selectedManufacturers.forEach(name => params.append('manufacturers[]', name));
      }
    }

    if (paging) {
      params.append('page', paging.currentPage.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedClientEspNdcs>(
      `${environment.captureApi.url}/client_esp_ndcs?${params.toString()}`
    );
  }

  getManufacturers(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.captureApi.url}/client_esp_ndcs/manufacturers`);
  }
}
